var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.447
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_639",
    "data-name": "Ellipse 639",
    cx: 56,
    cy: 56,
    r: 56,
    transform: "translate(-11068.963 -24841.963)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.54,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0070b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0070b6",
    stopOpacity: 0.082
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.046,
    y1: 0.387,
    x2: 0.643,
    y2: 0.529,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.796
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.051
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.343,
    x2: 0.603,
    y2: 0.829,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.361,
    y1: 0.358,
    x2: 0.918,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.424
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: -0.1,
    x2: 0.5,
    y2: 0.635,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.796
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.278,
    y1: 0,
    x2: 0.575,
    y2: 0.706,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6264",
    "data-name": "Group 6264",
    transform: "translate(1695 -4233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_40",
    "data-name": "Mask Group 40",
    transform: "translate(9373.963 29074.963)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Dot_Pattern-Small",
    "data-name": "Dot Pattern-Small",
    d: "M165.354,252.724a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,252.724Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,252.724Zm-11.414,0A1.631,1.631,0,1,1,61,254.354,1.631,1.631,0,0,1,62.631,252.724ZM165.354,241.31a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,241.31Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,241.31Zm-11.414,0A1.631,1.631,0,1,1,61,242.941,1.631,1.631,0,0,1,62.631,241.31ZM165.354,229.9a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,229.9Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,229.9Zm-11.414,0A1.631,1.631,0,1,1,61,231.527,1.631,1.631,0,0,1,62.631,229.9Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,218.482Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,218.482Zm-11.414,0A1.631,1.631,0,1,1,61,220.113,1.631,1.631,0,0,1,62.631,218.482Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,207.069Zm-11.414,0A1.631,1.631,0,1,1,140.9,208.7,1.631,1.631,0,0,1,142.527,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,207.069Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,207.069Zm-11.414,0A1.631,1.631,0,1,1,61,208.7,1.631,1.631,0,0,1,62.631,207.069Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,195.655Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,195.655Zm-11.414,0A1.631,1.631,0,1,1,61,197.286,1.631,1.631,0,0,1,62.631,195.655Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,184.241Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,184.241Zm-11.414,0A1.631,1.631,0,1,1,61,185.872,1.631,1.631,0,0,1,62.631,184.241Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,172.827Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,172.827Zm-11.414,0A1.631,1.631,0,1,1,61,174.458,1.631,1.631,0,0,1,62.631,172.827Zm102.724-11.414a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,161.414Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,161.414Zm-11.414,0A1.631,1.631,0,1,1,61,163.044,1.631,1.631,0,0,1,62.631,161.414ZM165.354,150a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,165.354,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,153.941,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,142.527,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,131.113,150ZM119.7,150a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,119.7,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,108.286,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,96.872,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,85.458,150Zm-11.414,0a1.631,1.631,0,1,1-1.631,1.631A1.631,1.631,0,0,1,74.044,150Zm-11.414,0A1.631,1.631,0,1,1,61,151.631,1.631,1.631,0,0,1,62.631,150Z",
    transform: "translate(-11127.139 -24988.914)",
    fillRule: "evenodd",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5767",
    "data-name": "Group 5767",
    transform: "translate(24 -360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG",
    transform: "translate(0 304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5756",
    "data-name": "Group 5756"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_123",
    "data-name": "Ellipse 123",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(-1695 4313)",
    fill: "#0070b6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5219",
    "data-name": "Group 5219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4139",
    "data-name": "Group 4139",
    transform: "translate(-1679.72 4632.279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1071",
    "data-name": "Rectangle 1071",
    width: 42.189,
    height: 42.189,
    transform: "translate(-4.235 -4.234)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "brightness_auto-24px",
    transform: "translate(-10.228 -10.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M0,0H27V27H0Z",
    transform: "translate(13.446 13.446)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M19.055,0l5.577,5.577h7.9v7.9l5.577,5.577-5.577,5.577v7.9h-7.9L19.055,38.11l-5.577-5.577h-7.9v-7.9L0,19.055l5.577-5.577v-7.9h7.9ZM29.189,8.921H23L19.055,4.972,15.106,8.921H8.921v6.185L4.972,19.055,8.921,23v6.185h6.185l3.535,4.364L23,29.189h6.185V23l3.949-3.949-3.949-3.949Z",
    transform: "translate(26.948 0) rotate(45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M-3.845,13.561l3.469,1.194-4.388,4.4,4.214,4.33L-3.817,24.72-9.4,19.152Z",
    transform: "translate(17.336 7.831)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M11.228-20.216h2.051L6.765-7.944H4.714ZM7.5-16.8a3.337,3.337,0,0,1-.73,2.3,2.633,2.633,0,0,1-2.075.82,2.654,2.654,0,0,1-2.092-.82,3.337,3.337,0,0,1-.73-2.3,3.307,3.307,0,0,1,.738-2.305A2.673,2.673,0,0,1,4.7-19.921a2.652,2.652,0,0,1,2.067.812A3.307,3.307,0,0,1,7.5-16.8ZM4.7-15.113a.571.571,0,0,0,.443-.205,1.1,1.1,0,0,0,.2-.525,6.6,6.6,0,0,0,.049-.911,8.137,8.137,0,0,0-.041-.919,1.408,1.408,0,0,0-.189-.582.5.5,0,0,0-.459-.238.553.553,0,0,0-.582.451,4.5,4.5,0,0,0-.123,1.157,5.556,5.556,0,0,0,.082,1.091,1.082,1.082,0,0,0,.23.533A.532.532,0,0,0,4.7-15.113Zm11.337,3.757a3.356,3.356,0,0,1-.722,2.305,2.642,2.642,0,0,1-2.084.812,2.659,2.659,0,0,1-2.084-.82,3.313,3.313,0,0,1-.738-2.3,3.331,3.331,0,0,1,.73-2.305,2.647,2.647,0,0,1,2.075-.812,2.673,2.673,0,0,1,2.084.812A3.307,3.307,0,0,1,16.035-11.356ZM13.23-9.666a.55.55,0,0,0,.394-.139.961.961,0,0,0,.221-.509,5.631,5.631,0,0,0,.074-1.042,5.61,5.61,0,0,0-.074-1.05.909.909,0,0,0-.23-.5.6.6,0,0,0-.418-.139.491.491,0,0,0-.459.263,1.517,1.517,0,0,0-.18.607q-.033.345-.033.82a7.95,7.95,0,0,0,.041.9,1.22,1.22,0,0,0,.2.566A.534.534,0,0,0,13.23-9.666Z",
    transform: "translate(7.88 31.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M-11945.779-343.679v4.489l-4.367,4.3-6.085-.274-3.051-2.906h7.962Z",
    transform: "translate(11962.499 341.391)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M-11952.923-344.689l3.367,1.437-.238,7.64h-7.727l-1.174-3.486h5.526Z",
    transform: "translate(11979.834 365.833)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M-11936.73-321.089h.99l-6.517,12.27h-.978",
    transform: "translate(11955.855 332.038)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M-11944.628-320.555a5.58,5.58,0,0,0-1.105,0,2.773,2.773,0,0,0-1.7,1.162,3.316,3.316,0,0,0-.395,2.1,31.826,31.826,0,0,0,2.814-2.372A3.173,3.173,0,0,0-11944.628-320.555Z",
    transform: "translate(11957.771 331.829)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M-11944.628-320.555a5.58,5.58,0,0,0-1.105,0,2.773,2.773,0,0,0-1.7,1.162,3.316,3.316,0,0,0-.395,2.1,31.826,31.826,0,0,0,2.814-2.372A3.173,3.173,0,0,0-11944.628-320.555Z",
    transform: "translate(11966.359 337.103)",
    fill: "url(#linear-gradient-5)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.d6e15dc79476591cb534602afd375231.svg";
export { ForwardRef as ReactComponent };